import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

// GET /ajax/invoice/{invoice_header_id}
export const invoiceDetails = async (invoiceHeaderId: number) => {
  const response = await new Request().get('/ajax/invoice/' + invoiceHeaderId)
  return Util.Obj.keysToCamel(response.data)
}
